import React, {useEffect, useState} from 'react'
import { Box, SimpleGrid, Text, InputGroup, Input, InputRightElement, Button } from '@chakra-ui/react'
import { 
	BASE_API_URL, 
	CHAIN_ID, 
	NFT_ADDRESS, 
	PAGE_SIZE,
	MAIN_COLOR,
} from '../../config';
import {ItemBar} from "./ItemBar";
// import {Banner} from "./Banner";
import {useAuth} from '../../contexts/AuthContext';
import { AiOutlineSearch } from "react-icons/ai";

const ItemList = (props) => {
	const [currentPage, setCurrentPage ] = useState(0);
	const [nftData, setNftData] = useState([]);
	const [strType, setStrType] = useState('');
	const [searchKey, setSearchKey] = useState('');
	const [currentPlayingId, setCurrentPlayingId] = useState(-1); // No player is playing

	const {
		currentAccount,
		jwToken,
		setMyFavourTokenId,
	} = useAuth();
	
	useEffect(() => {
		if(strType !== '') return;
		// console.log(props.type)
			// onsale - 0, myOnsale - 1, unlisted - 5(not mine), myUnlisted - 3, all - 4
		switch(props.type) {
			case 0: {
				setStrType('Onsale NFTs');
				break;
			}
			case 1: {
				setStrType('My Onsale NFTs');
				break;
			}
			case 3: {
				setStrType('My NFTs not onsale');
				break;
			}
			case 5: {
				setStrType('NFTs not onsale');
				break;
			}
			default: setStrType('All NFTs');
		}
	}, [props.type])

	const loadData = async (signal) => {
		// load data from db
		// console.log("==== loadData type " + props.type + " ====");
		if(jwToken === undefined) return;
		let url = `${BASE_API_URL}/items/get_nfts/`;

		let res = await fetch(url, {
			method: "post",
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				"chainId": CHAIN_ID,
				"nftAddress": NFT_ADDRESS,
				// "collection": DEFAULT_COLLECTION_ID,
				// "category": DEFAULT_CATEGORY_ID,
				"status": 0,
				"createAt": 1,
				"createAtDesc": 1,
				"price": 1,
				"priceDesc": 1,
				"staking": 1,
				"stakingDesc": 1,
				"like": 1,
				"likeDesc": 1,
				"tokenIdDesc": 1,
				"seller": currentAccount,
				"type": props.type, // onsale - 0, myOnsale - 1, unlisted - 5(not mine), myUnlisted - 3, all - 4
				"offset": currentPage,
				"rows": PAGE_SIZE,
				"searchKey": searchKey,
			}),
			signal,
		})
		let data = await res.json();
		console.log("get_nfts", data.list)
		if(data.success) setNftData(data.list);
		
		// Get my favorite nfts tokenId
		url = `${BASE_API_URL}/items/get_my_favours`;
		res = await fetch(url, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': jwToken
			}, 
			body: JSON.stringify({
				"chainId": CHAIN_ID,
				"nftAddress": NFT_ADDRESS,
				"address": currentAccount
			})
		})
		data = await res.json();
		// console.log('Favor tokenIds', data.tokenIds);
		setMyFavourTokenId(data.tokenIds);
	}

	useEffect(() => {
		// console.log("currentAccount", currentAccount)
		const controller = new AbortController();
		const signal = controller.signal;

		if(currentAccount !== undefined) loadData(signal);
		return() => controller.abort();
	}, [jwToken]);
	
	const handleSearchClick = (event) => {
		doSearch(searchKey)
	}

	const handleSearchKeyUp = (event) => {
		if(event.key === 'Enter') {
			doSearch(searchKey);
		}
	}

	const doSearch = async (key) => {
		if(key === undefined || key === '') return;
		const controller = new AbortController();
		const signal = controller.signal;
		await loadData(signal);
	}

	return (
		<Box>
			<Box 
				w={["100%", "90%", "80%", "70%", "70%"]}
				mt={'60px'}
				ml={["0", "5%", "10%", "15%", "15%"]}
				textAlign="center"

			>
				{/* <Banner/> */}
				<Text
				 color={"white"}
				 fontWeight={600}
				 mt={8}
				 mb={5}
				 fontSize={"30px"}
				 w={"full"}
				>
					{strType}
				</Text>
				<Box bg={MAIN_COLOR} h={'5px'} w={'4%'} mx={'48%'} mb={'40px'}></Box>

				{/* Search */}
				<Box w={["80%", "80%", "80%", "70%", "70%"]} ml={["10%", "10%", "10%", "15%", "15%"]}>
					<InputGroup size='md'>
						<Input
							value={searchKey}
							color={"white"}
							pr='4.5rem'
							type={"text"}
							placeholder='Search by'
							onKeyUp={handleSearchKeyUp}
							onChange={(e) => setSearchKey(e.target.value)}
						/>
						<InputRightElement>
							<Button bg={'#ffffff00'} color={MAIN_COLOR} h='1.75rem' size='sm' onClick={handleSearchClick}>
								<AiOutlineSearch size='24px' />
							</Button>
						</InputRightElement>
					</InputGroup>
				</Box>

				{/* NFT List */}
				<Box mb={'60px'}>
				<SimpleGrid columns={[1, 2, 2, 3, 4]} spacing={10}>
				{nftData.map((v, i) => 
					<ItemBar 
						key={i} 
						data={v}
						type={props.type}
						setCurrentPlayingId={(bl) => setCurrentPlayingId(bl ? i : -1)}
						isPlay={i === currentPlayingId}
					/>
				)}
				</SimpleGrid>
				</Box>
		</Box>
		</Box>
		)
	}
	
	export default ItemList